const EmailPreview = ({ mailBody }) => {
  const createEmailPreview = () => {
    return { __html: mailBody };
  };
  return (
    <div className="col-sm-9 offset-sm-3">
      <hr></hr>
      <h4 className="sub-heading">Preview Before You Send!</h4>
      <div
        className="mail-preview-container"
        dangerouslySetInnerHTML={createEmailPreview()}
      />
    </div>
  );
};

export default EmailPreview;
